<template>
  <v-dialog :value="visible" @input="$emit('close')" max-width="520" persistent>
    <v-card>
      <v-card-title>{{
        isEdit ? "Edit Network" : "Create Network"
      }}</v-card-title>
      <v-card-text>
        <div v-if="is_loading_network">Loading...</div>
        <v-form v-else ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="form.name"
            label="Name *"
            :rules="[rules.required]"
            counter="64"
            maxlength="64"
          />
          <v-text-field
            v-model="form.slug"
            label="Slug *"
            :rules="[rules.required]"
            counter="64"
            maxlength="64"
            hint="Used in webworker URLs"
          />
          <v-text-field
            v-model="form.visit_id_param"
            label="Visit ID Param *"
            :rules="[rules.required]"
            maxlength="64"
            placeholder="e.g. sub1, click_id"
            hint="GET parameter name for visit tracking"
          />
          <v-text-field
            v-model="form.pixel_id_param"
            label="Pixel ID Param"
            maxlength="16"
            clearable
            hint="Optional parameter for pixel tracking"
          />
          <v-switch v-model="form.is_public" label="Public" class="mt-2" />
          <!-- <v-text-field
            v-model.number="form.sort"
            label="Sort Order"
            type="number"
            min="0"
          /> -->
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('close')">Cancel</v-btn>
        <v-btn
          color="primary"
          :loading="saving"
          :disabled="!valid"
          @click="save"
        >
          {{ isEdit ? "Update" : "Create" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  createNetwork,
  updateNetwork,
  getNetwork,
} from "@/store/modules/advertisers/api";
import { requestStatus } from "@/services/services";

export default {
  name: "NetworkDialog",
  props: {
    visible: Boolean,
    network: Object,
  },
  data: () => ({
    valid: true,
    saving: false,
    is_loading_network: false,
    form: {
      name: "",
      slug: "",
      visit_id_param: "",
      pixel_id_param: "",
      is_public: true,
      sort: 0,
    },
    rules: {
      required: (v) => !!v || "This field is required",
    },
  }),
  computed: {
    isEdit() {
      return !!(this.network && this.network.id);
    },
  },
  watch: {
    visible(open) {
      if (open) {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      if (this.network) {
        this.is_loading_network = true;
        getNetwork(this.network.id)
          .then((response) => {
            if (response.status === requestStatus.success) {
              this.form = {
                name: response.response.data.name || "",
                slug: response.response.data.slug || "",
                visit_id_param: response.response.data.visit_id_param || "",
                pixel_id_param: response.response.data.pixel_id_param || "",
                is_public: response.response.data.is_public !== false,
                sort: response.response.data.sort || 0,
              };
            } else {
              this.$toaster.error(
                response.messages || "Failed to load network data",
              );
              this.resetForm();
              this.$emit("close");
            }
          })
          .finally(() => {
            this.is_loading_network = false;
          });
      } else {
        this.form = {
          name: "",
          slug: "",
          visit_id_param: "",
          pixel_id_param: "",
          is_public: true,
          sort: 0,
        };
      }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },

    save() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      const payload = {
        name: this.form.name,
        slug: this.form.slug,
        visit_id_param: this.form.visit_id_param,
        pixel_id_param: this.form.pixel_id_param || null,
        is_public: this.form.is_public,
        sort: this.form.sort,
      };

      const apiCall = this.isEdit
        ? updateNetwork(this.network.id, payload)
        : createNetwork(payload);

      apiCall
        .then((response) => {
          if (response.status === requestStatus.success) {
            this.$toaster.success(
              this.isEdit
                ? "Network updated successfully"
                : "Network created successfully",
            );
            this.$emit("saved");
          } else {
            this.$toaster.error(response.messages || "Operation failed");
          }
        })
        .finally(() => (this.saving = false));
    },
  },
};
</script>

<style scoped></style>
